import React from 'react'

const Copyright = () => {
  return (
    <div className='d-flex flex-column gap-2'>
        <span>Copyright &#169; 2024 Sequence.</span>
        <span>All rights reserved to Dvir Aviram.</span>
        <span>No part of this site may be reproduced without permission.</span>
    </div>
  )
}

export default Copyright